import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { SCAN_UPDATE } from "./gql";

const useScanUpdate = createDefaultMutationHook(SCAN_UPDATE);

export default useScanUpdate;
